// JavaScript for room number input field
$(function () {

  var currentVal;
  var fieldName = $('.btn-number').attr('data-field');
  var input = $('input[name="' + fieldName + '"]');
  var hotelImage = document.getElementById('hotelImage');
  currentVal = parseInt(input.val());


  // Room number input field and guided selling button
  $('.btn-number').each(function () {
    $(this).click(function (e) {
      e.preventDefault();
      var type = $(this).attr('data-type');
      if (!isNaN(currentVal)) {
        if (type == 'minus') {
          if (currentVal > input.attr('min')) {
            input.val(currentVal - 1).change();
            currentVal = parseInt(input.val());
          }
          if (parseInt(input.val()) == input.attr('min')) {
            $(this).attr('disabled', true);
          }
        } else if (type == 'plus') {
          if (currentVal < input.attr('max')) {
            input.val(currentVal + 1).change();
            currentVal = currentVal = parseInt(input.val());
          }
          if (parseInt(input.val()) == input.attr('max')) {
            $(this).attr('disabled', true);
          }
        }
      } else {
        input.val(0);
      }
    });
  });

  $('.input-number').each(function () {
    $(this).focusin(function () {
      $(this).data('oldValue', $(this).val());
    });
    $(this).change(function () {
      var minValue = parseInt($(this).attr('min'));
      var maxValue = parseInt($(this).attr('max'));
      currentVal = parseInt($(this).val());
      var name = $(this).attr('name');
      if (currentVal >= minValue) {
        $('.btn-number[data-type="minus"][data-field="' + name + '"]').removeAttr('disabled')
      } else {
        alert('Sorry, the minimum value was reached');
        $(this).val($(this).data('oldValue'));
      }
      if (currentVal <= maxValue) {
        $('.btn-number[data-type="plus"][data-field="' + name + '"]').removeAttr('disabled')
      } else {
        alert('Sorry, the maximum value was reached');
        $(this).val($(this).data('oldValue'));
      }
      if (hotelImage) {
        if (currentVal <= 5) {
          hotelImage.src = 'https://resources.littlehotelier.com/pricing/hotel-01.svg';
        } else if (currentVal >= 6 && currentVal <= 10) {
          hotelImage.src = 'https://resources.littlehotelier.com/pricing/hotel-02.svg';
        } else if (currentVal >= 11 && currentVal <= 20) {
          hotelImage.src = 'https://resources.littlehotelier.com/pricing/hotel-03.svg';
        } else if (currentVal >= 21) {
          hotelImage.src = 'https://resources.littlehotelier.com/pricing/hotel-04.svg';
        }
      }
    });

    $(this).keydown(function (e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
      currentVal = parseInt($('.input-number').val());
    });
  });
});



// WEBPACK FOOTER //
// ./scripts/routes/inputRooms.js